const apiUrl = process.env.REACT_APP_API_URL;
export const GetUsuarisIdProjectes = async (id : string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/usuaris/${id}/projectes`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
